import { useEffect, useState } from "react";
import {DsaPlaylistDto, DsaScheduleDto, DsaScreenDto, LocationDto} from "../../generated/dashboard-client"
import { Button, Checkbox } from "antd";
import { locationsState } from "../../state/atoms";
import { useRecoilState } from "recoil";
import "./PushToScreenMenu.scss";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface PushToScreenMenuProps {
  playlist?: DsaPlaylistDto | null;
  schedule?: DsaScheduleDto | null;
  onPlaylistPush?: (playlist: DsaPlaylistDto, screens: DsaScreenDto[]) =>  void;
  onSchedulePush?: (schedule: DsaScheduleDto, screens: DsaScreenDto[]) =>  void;
  pushLoading: boolean;
  setDropdownView?: (view: string) => void;
  screens: DsaScreenDto[];
}

export default function PushToScreenMenu({playlist, onPlaylistPush, schedule, onSchedulePush, pushLoading, setDropdownView, screens}: PushToScreenMenuProps) {
  const [loading, ] = useState(false);
  const [locations] = useRecoilState(locationsState);
  const [selectedLocation, setSelectedLocation] = useState({} as LocationDto);
  const [selectedScreens, setSelectedScreens] = useState([] as DsaScreenDto[]);
  const [view, setView] = useState('locations');
  const [locsWithScreens, setLocsWithScrens] = useState([] as LocationDto[])

  useEffect(() => {
    const withScreens = locations.filter(loc => screens.filter(sc => sc.locationId === loc.internalId).length > 0);
    setLocsWithScrens(withScreens);
    if (withScreens.length === 1) {
      setSelectedLocation(withScreens[0]);
      setView('screens');
    }
  }, [locations, screens])

  function onPushClick() {
    if (selectedScreens.length === 0) return;
    if (playlist !== null) {
      onPlaylistPush?.(playlist!, selectedScreens);
    }
    if (schedule !== null) {
      onSchedulePush?.(schedule!, selectedScreens);
    }
  }

  function onLocationClick(e: any, loc: LocationDto) {
    e.stopPropagation();
    setView('screens');
    setSelectedLocation(loc);
  }

  function backToLocations(e: any) {
    e.stopPropagation();
    if (locsWithScreens.length <= 1 && setDropdownView) {
      setDropdownView('options');
    }
    setView('locations');
    setSelectedLocation({});
  }

  function onCheckClick(screen: DsaScreenDto, e: CheckboxChangeEvent) {
    e.stopPropagation();
    if (e.target.checked && !selectedScreens.map(sc => sc.serial).includes(screen.serial)) {
      setSelectedScreens([screen, ...selectedScreens]);
    } else {
      setSelectedScreens(selectedScreens.filter(sc => sc.serial !== screen.serial));
    }
  }

  function backToMenu(e: any) {
    e.stopPropagation();
    if (setDropdownView) {
      setDropdownView('options');
    }
  }

  return <div className="push-to-screen-menu">
    {setDropdownView && view === 'locations' &&
    <div className="back-option" onClick={(e) => backToMenu(e)}>
      <LeftOutlined/><b>Push to Screens</b>
    </div>}
    {view === 'locations' && <ul className='locations'>
      {locsWithScreens.map(loc => <li onClick={(e) => onLocationClick(e, loc)} key={loc.id}>
        <div>
          <span className="name">{loc.name}</span>
          <span className="selected-screens">
            {selectedScreens.filter(sc => sc.locationId === loc.internalId).map(sc => sc.name).join(', ')}
          </span>
        </div>
        <RightOutlined/>
      </li>)}
    </ul>}
    {view === 'screens' && <>
      <div className={`back-option ${!setDropdownView && locsWithScreens.length <= 1 ? 'no-hover' : ''}`} onClick={(e) => backToLocations(e)}>
        {(setDropdownView || (!setDropdownView && locsWithScreens.length > 1)) && <LeftOutlined/>}<b>{selectedLocation.name}</b>
      </div>
      <ul className='screens'>
        {screens
        .filter(sc => sc.locationId === selectedLocation.internalId)
        .map(sc => <li onClick={(e) => {e.stopPropagation()}} key={sc.serial}>
          <Checkbox onChange={(e) => onCheckClick(sc, e)} checked={selectedScreens.map(s => s.serial).includes(sc.serial)}/>{sc.name}
        </li>)}
      </ul>
    </>}
    <footer onClick={(e) => {e.stopPropagation()}}>
      <Button type="primary" onClick={() => onPushClick()} loading={loading || pushLoading} className={selectedScreens.length === 0 ? 'disabled' : ''}>Push to Screens</Button>
    </footer>
  </div>
}
